import { datalayerSimpleEvent } from '@smuchile/pkg-unimarc-hooks'
import { IAuthRegisterErrorData } from '@smuchile/pkg-unimarc-hooks/shared/interfaces'

const defaultErrorMessage = null

const errorMessages = {
  SSO_33: 'Este correo ya tiene una cuenta asociada.'
}

export const getEmailErrorMessage = (error: IAuthRegisterErrorData) => {
  const code = error.error?.code

  const safeErrorMessage = errorMessages[`${code}`]

  safeErrorMessage &&
    datalayerSimpleEvent({
      event: 'register',
      eventAction: 'notification',
      eventCategory: 'validations',
      eventLabel: 'email_in_use'
    })

  return safeErrorMessage ?? defaultErrorMessage
}
